import { AxiosMULEEX, AxiosBookings, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";
//import store from '../../store';

export const routesApiFactory = {
  $_getAllRoutes(params = {}) {
    let url = `/shippingservices/org/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getAllNewShippingService(params = {}) {
    let url = `/shippingservices/filter/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getAllTerminals(){
    let url = `/route/terminal/all/${localStorage.getItem('organizationId')}`;
    return AxiosMULEEX.get(url);
  },
  $_getTerminalsByState(state){
    let url = `/terminal-on-location/all/${localStorage.getItem('organizationId')}?state=${state}`;
    return AxiosMULEEX.get(url);
  },
  $_createRoute(payload) {
    let url = "/shippingservices";
    
    return AxiosBookings.post(url, payload);
  },
  $_getCitiesByState(state) {
    let url = `shippingservices/cities/${state}`;

    return AxiosBookings.get(url);
  },
  $_deleteCityFromRoute(cityId){
    let url = `/shippingservices/city/${cityId}`
    return AxiosBookings.delete(url);
  },
  $_addCityToRoute(payload, routeId){
    let url = `/shippingservices/city/${routeId}`
    return AxiosBookings.post(url, payload);
  },
  $_deleteRoute(routeId) {
    let url = `/shippingservices/${routeId}`
    return AxiosBookings.delete(url);
  },
  $_getSingleRoute(routeId) {
    let url = `shippingservices/${routeId}`
    return AxiosBookings.get(url);
  },
  $_updateRoute(payload,routeId) {
   let url = `/shippingservices/${routeId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_getFilteredRoutes(params){
    let url = `/shippingservices/filter/${orgId()}${appendQueryParams(params)}`
    return AxiosBookings.get(url);
  },
  $_getAllCities(){
    let url = `/shippingservices/cities/all`
    return AxiosBookings.get(url);
  }
};
